import { ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { ColumnInfoService, ColumnMenuService } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-alphabetical-column-chooser',
  template: `
    <div
      class="k-columnmenu-item"
      role="button"
      [attr.aria-expanded]="expanded"
      (click)="toggle()"
      (keydown.enter)="toggle()">
      <span class="k-icon k-i-columns"></span>
      Columns
    </div>
    <div [style.display]="expanded ? 'block' : 'none'" class="k-columnmenu-item-content">
      <div class="k-column-list">
        <label
          *ngFor="let col of columnStates"
          class="k-column-list-item"
          [style.cursor]="'pointer'">
          <input
            class="k-checkbox"
            type="checkbox"
            [checked]="col.visible"
            (change)="onCheckChange(col, $event)" />
          <span class="k-checkbox-label">{{ col.title }}</span>
        </label>
      </div>
      <div class="k-columnmenu-actions">
        <button type="button" class="k-button" (click)="onReset()">Reset</button>
        <button type="button" class="k-button k-primary" (click)="onApply()">Apply</button>
      </div>
    </div>
  `,
})
export class AlphabeticalColumnChooserComponent implements OnInit {
  @HostBinding('class.k-columnmenu-item-wrapper') readonly hostClass = true;

  @Input() service: ColumnMenuService;

  expanded = false;

  /** Snapshot of column visibility state used for the checklist. */
  columnStates: Array<{ column: any; title: string; visible: boolean }> = [];

  constructor(
    private columnInfoService: ColumnInfoService,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.buildColumnStates();
  }

  toggle(): void {
    this.expanded = !this.expanded;
    if (this.expanded) {
      this.buildColumnStates();
    }
    this.changeDetector.detectChanges();
  }

  onCheckChange(col: { column: any; title: string; visible: boolean }, event: Event): void {
    col.visible = (event.target as HTMLInputElement).checked;
  }

  onReset(): void {
    this.buildColumnStates();
    this.changeDetector.detectChanges();
  }

  onApply(): void {
    const changed = this.columnStates
      .filter(s => s.column.hidden === s.visible) // hidden !== intended visible
      .map(s => {
        s.column.hidden = !s.visible;
        return s.column;
      });
    if (changed.length) {
      this.columnInfoService.changeVisibility(changed);
    }
    this.service.close();
  }

  private buildColumnStates(): void {
    const cols: any[] = this.columnInfoService?.leafNamedColumns || [];
    this.columnStates = [...cols]
      .sort((a, b) =>
        (a.displayTitle || '').localeCompare(b.displayTitle || '', undefined, { numeric: true, sensitivity: 'base' }),
      )
      .map(col => ({
        column: col,
        title: col.displayTitle || col.field || '',
        visible: !col.hidden,
      }));
  }
}

